import { Button, LinearProgress } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { editApplication } from '../../../actions/applications'
import { navigate } from '../../../actions/routes'
import Container from '../../../components/Container'
import {
  selectApplicationByApartmentIdAndApplicationId,
  selectIsApplicationsLoading
} from '../../../selectors/applications'
import {
  selectContentIdFromPathname as selectApartmentIdFromPathname,
  selectUserIdFromPathname as selectApplicationIdFromPathname
} from '../../../selectors/router'
import { selectIsAdminUser } from '../../../selectors/users'
import { StateInterface } from '../../../types/states'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import EditApplicationForm from './EditApplicationForm'

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectApartmentIdFromPathname(state)
  const applicationId = selectApplicationIdFromPathname(state)
  return {
    application:
      !!applicationId && !!apartmentId
        ? selectApplicationByApartmentIdAndApplicationId({
            apartmentId,
            applicationId
          })(state)
        : undefined,
    applicationsLoading: selectIsApplicationsLoading(state),
    isAdmin: selectIsAdminUser(state)
  }
}

type PropsFromState = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = (dispatch: Dispatch) => ({
  editApplicationAction: bindSubmitActionToPromise(dispatch, editApplication),
  doNavigate: (path: string) => dispatch(navigate(path))
})

type DispatchProps = ReturnType<typeof mapDispatchToProps>

type ApplicationProps = PropsFromState & DispatchProps & WithTranslation

const EditApplication: FC<ApplicationProps> = ({
  t,
  editApplicationAction,
  doNavigate,
  application,
  applicationsLoading,
  isAdmin
}: ApplicationProps) => (
  <Container>
    {isAdmin && (
      <Fragment>
        {
          <Fragment>
            <Button
              variant='contained'
              color='primary'
              onClick={() => doNavigate('/apartments')}
            >
              {t('apartment.end.backToApartments')}
            </Button>
          </Fragment>
        }
        {applicationsLoading && <LinearProgress />}
        {!applicationsLoading && application && (
          <EditApplicationForm
            initialValues={application}
            editApplicationAction={editApplicationAction}
            doNavigate={doNavigate}
          />
        )}
      </Fragment>
    )}
  </Container>
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EditApplication))
